import type { FormEventHandler, ReactNode } from 'react';

import { FormProvider, type UseFormReturn } from 'react-hook-form';

interface FormProps {
  // Shape-agnostic on purpose: the Form wrapper just hosts the provider. Per-field
  // type-safety happens inside Field.Text → Controller via useFormContext<TFieldValues>().
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  methods: UseFormReturn<any>;
  onSubmit?: FormEventHandler<HTMLFormElement>;
  children: ReactNode;
}

// Wraps RHF's <FormProvider> + a native <form>. Mirrors v1's `<Form methods>` pattern:
// any descendant Field.* component reads `control` from the context via useFormContext,
// removing the need to thread `control` as a prop through every field.
export function Form({ methods, onSubmit, children }: FormProps) {
  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit} noValidate autoComplete="off">
        {children}
      </form>
    </FormProvider>
  );
}
